// extracted by mini-css-extract-plugin
module.exports = {"globe-tail":"ParticipationFeedbackCard__globe-tail___poEow"};